import { useEffect } from 'react';

// Every tab is "The Sweet Spot - <Area>", with deeper pages nesting
// segments ("Inventory/Inventory Counts/Start a Shelf Count"). Pages with no
// specific title (login, error states) fall back to the bare site name.
const SITE_TITLE = 'The Sweet Spot';

export function useDocumentTitle(segments?: string[]): void {
  const path = segments?.filter(Boolean).join('/') || undefined;
  useEffect(() => {
    document.title = path ? `${SITE_TITLE} - ${path}` : SITE_TITLE;
  }, [path]);
}
